<template>
<div class="chapter">
<div class="inner_page">
<p class="center3"><span><a id="page_6"><span class="brown"><b>Get in on the fun by posting pictures to Instagram using #dessertmashups and tagging @crazyforcrust!</b></span></a></span></p><a id="page_6">
<p class="image"><span><img alt="" height="550" src="images/f0006-01.jpg" width="413"/></span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter.vue?358e4c6e